import { render, staticRenderFns } from "./PacienteArchivos.vue?vue&type=template&id=4a037a90&"
import script from "./PacienteArchivos.vue?vue&type=script&lang=js&"
export * from "./PacienteArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports